//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyController_findOneById,
  Response$AdminCompanyController_findOneById$Status$200,
  ResponseContentType$AdminCompanyController_findOneById,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminCompanyController_findOneById = (options: {
  params: Params$AdminCompanyController_findOneById['parameter'];
  config?: QueryOptions<
    Response$AdminCompanyController_findOneById$Status$200[ResponseContentType$AdminCompanyController_findOneById]
  >;
}) =>
  useApiClient<
    Params$AdminCompanyController_findOneById,
    Response$AdminCompanyController_findOneById$Status$200[ResponseContentType$AdminCompanyController_findOneById]
  >({
    method: 'AdminCompanyController_findOneById',
    params: { parameter: options.params },
    config: options.config,
  });
